import React, { useContext, useEffect } from "react";
import "../css/editblog.css";
import UserContext from "../context/users/UserContext";
import BlogContext from "../context/blogs/BlogContext";
// import { useParams } from "react-router";
function Myaccount(props) {
  const usercontext = useContext(UserContext);
  const blogcontext=useContext(BlogContext)
//   const params=useParams();
  useEffect(()=>{
      blogcontext.getMyBlog();
      // eslint-disable-next-line
  },[])
  return (
    <>
      <div className="myaccountcontainer">
        <div className="totalBlogs">
          <span>{blogcontext.myBlog?blogcontext.myBlog.totalArticle:undefined}</span>
          <span>Total Blog</span>
        </div>
        <div className="userDetails">
          <div className="userdetailbox">
            <label>Name : </label>
            <span>{usercontext.userDetails.name}</span>
          </div>
          <div className="userdetailbox">
            <label>Email : </label>
            <span>{usercontext.userDetails.email}</span>
          </div>
          <div className="userdetailbox">
            <label>Account Created at : </label>
            <span>{new Date(usercontext.userDetails.date).toDateString()}</span>
          </div>
        </div>
      </div>
    </>
  );
}

export default Myaccount;
